import { getData } from 'actions/profile';

export const getDataAfterPassword = (dispatch:func = () => {}, success) => {
	return new Promise((resolve, reject) => {
		dispatch(getData(null, { resolve, reject, success }));
	});
};
